import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-3" };
const _hoisted_2 = ["data-testid"];
const _hoisted_3 = { class: "flex items-center justify-between gap-2" };
const _hoisted_4 = { class: "text-[length:var(--size-l)] font-[var(--weight-bold)] text-(--text-text-black-default)" };
const _hoisted_5 = {
    key: 0,
    class: "text-[length:var(--size-m)] text-(--text-text-body-subtle)"
};
const _hoisted_6 = { class: "text-[length:var(--size-m)] text-(--text-text-error)" };
const _hoisted_7 = { class: "text-[length:var(--size-m)] text-(--text-text-body-subtle)" };
const _hoisted_8 = {
    key: 0,
    class: "text-[length:var(--size-m)] text-(--text-text-body-subtle)"
};
const _hoisted_9 = {
    key: 1,
    class: "flex flex-col gap-0.5"
};
const _hoisted_10 = ["data-testid"];
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Badge } from "@eudonet/opal";
import { FAILURE_CODES, IMPACT_STATUSES } from "../../domain/request";
import { groupTargetFieldsByEntity, } from "../../domain/groupTargetFieldsByEntity";
import { entityLabel, foldUntranslatedEntities, impactBadgeTheme, serviceLabel, useRequestTranslator, vocabularyKey, } from "../requestLabels";
export default /*@__PURE__*/ _defineComponent({
    __name: 'RequestImpactList',
    props: {
        targets: {}
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const translator = useRequestTranslator();
        const entityGroups = computed(() => new Map(props.targets.map((target) => [
            target.serviceCode,
            foldUntranslatedEntities(translator, target.serviceCode, groupTargetFieldsByEntity(target.fields)),
        ])));
        const BUCKET_ORDER = ["wouldModify", "retainedLegal", "refused", "untouched", "unknown"];
        function outcomeSummary(group) {
            return BUCKET_ORDER.filter((bucket) => group.counts[bucket] > 0)
                .map((bucket) => t(`compliance.request.outcomes.${bucket}`, { count: group.counts[bucket] }))
                .join(" · ");
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.targets, (target) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: target.serviceCode,
                        class: "flex flex-col gap-1 rounded-lg border border-(--border-border-base-soft) px-4 py-3",
                        "data-testid": `request-impact-${target.serviceCode}`
                    }, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(serviceLabel)(_unref(translator), target.serviceCode)), 1 /* TEXT */),
                            _createVNode(_unref(Badge), {
                                theme: _unref(impactBadgeTheme)(target.impactStatus),
                                label: _unref(t)(_unref(vocabularyKey)('compliance.request.impactStatus', target.impactStatus, _unref(IMPACT_STATUSES))),
                                "show-close-icon": false
                            }, null, 8 /* PROPS */, ["theme", "label"])
                        ]),
                        (target.impactStatus === 'TimedOut')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(t)("compliance.pseudonymise.preview.timedOutNote")), 1 /* TEXT */))
                            : (target.impactStatus === 'Failed')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)(_unref(vocabularyKey)("compliance.request.failureCodes", target.impactFailureCode ?? "", _unref(FAILURE_CODES)))), 1 /* TEXT */),
                                    _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("compliance.pseudonymise.preview.failedNote")), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                                : (target.impactStatus === 'Reported')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        (entityGroups.value.get(target.serviceCode)?.length === 0)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(t)("compliance.pseudonymise.preview.nothingForService")), 1 /* TEXT */))
                                            : (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entityGroups.value.get(target.serviceCode), (group) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                        key: group.entity,
                                                        class: "text-[length:var(--size-m)] text-(--text-text-body)",
                                                        "data-testid": `request-impact-${target.serviceCode}-${group.entity || 'other'}`
                                                    }, _toDisplayString(_unref(entityLabel)(_unref(translator), target.serviceCode, group.entity)) + " · " + _toDisplayString(outcomeSummary(group)), 9 /* TEXT, PROPS */, _hoisted_10));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]))
                                    ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                    ], 8 /* PROPS */, _hoisted_2));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
